<template>
  <v-card v-if="intent" flat>
    <v-card-text>
      <template v-if="isBbq">
        <div class="form-control mb-3" style="display: flow-root">
          <span class="mt-2"> {{ $t('not_sending_message_to_the_same_person_within') }}</span>
          <input
            v-model="intent.not_reply_within_seconds"
            type="number"
            pattern="[0-9]*"
            placeholder="-"
            inputmode="numeric"
            class="form-control mx-4"
            style="width: 90px"
          />
          <span> {{ $t('minute') }}</span>
        </div>
        <div class="form-control mb-3" style="display: flow-root">
          <span class="mt-2">{{ $t('send_message_to_same_person') }}</span>
          <toggle-button
            :value="status"
            :sync="true"
            :color="$vuetify.theme.success"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block; margin: 0 12px"
            @change="onChangeToggle"
          />
        </div>
        <div v-if="status" class="form-control mb-3 pl-3" style="display: flow-root">
          <span class="mt-2">{{ $t('send_message_to_same_person') }}</span>
          <input
            v-model="intent.not_reply_within_times"
            type="number"
            pattern="[0-9]*"
            placeholder="-"
            inputmode="numeric"
            class="form-control mx-4"
            style="width: 90px"
          />
          <span> {{ $t('time_day') }}</span>
        </div>
        <div>
          <div class="mb-2">{{ $t('timer') }}</div>
          <v-radio-group v-model="onlytime">
            <v-radio
              :color="'primary'"
              :label="$t(`Turn On/Off Date & Time Setting for Bot's Reply`)"
              :value="false"
            ></v-radio>
            <v-radio
              :color="'primary'"
              :label="$t(`Selecting certain chatbot's answers for the certain time`)"
              :value="true"
            ></v-radio>
          </v-radio-group>
          <v-layout v-if="onlytime">
            <v-flex class="pr-1">
              <div class="form-control">
                <div class="caption">{{ $t('Turn-on Time') }}</div>
                <v-layout wrap>
                  <v-flex xs10 class="pl-1">
                    <v-menu
                      ref="openStartTime"
                      v-model="openStartTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="intent.start_time"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="intent.start_time"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-time-picker
                        v-if="openStartTime"
                        v-model="intent.start_time"
                        full-width
                        @click:minute="$refs.openStartTime.save(intent.start_time)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        intent.start_date = null
                        intent.start_time = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex class="pl-1">
              <div class="form-control">
                <div class="caption">{{ $t('Turn-off Time') }}</div>
                <v-layout wrap>
                  <v-flex xs10 class="pl-1">
                    <v-menu
                      ref="openEndTime"
                      v-model="openEndTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="intent.end_time"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="intent.end_time"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-time-picker
                        v-if="openEndTime"
                        v-model="intent.end_time"
                        full-width
                        @click:minute="$refs.openEndTime.save(intent.end_time)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        intent.end_date = null
                        intent.end_time = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-layout v-else>
            <v-flex class="pr-1">
              <div class="form-control">
                <div class="caption">{{ $t('Turn-on Time') }}</div>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openStartDate"
                      v-model="openStartDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="intent.start_date"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          clearable
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="intent.start_date"
                        color="primary"
                        @input="openStartDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openStartTime"
                      v-model="openStartTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="intent.start_time"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      :disabled="intent.start_date == null"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="intent.start_time"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          :disabled="intent.start_date == null"
                          v-on="on"
                        />
                      </template>
                      <v-time-picker
                        v-if="openStartTime"
                        v-model="intent.start_time"
                        full-width
                        @click:minute="$refs.openStartTime.save(intent.start_time)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        intent.start_date = null
                        intent.start_time = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex class="pl-1">
              <div class="form-control">
                <div class="caption">{{ $t('Turn-off Time') }}</div>
                <v-layout wrap>
                  <v-flex class="form-control" xs6 :class="{ 'has-error': errors.has('enddate') }">
                    <v-menu
                      ref="openEndDate"
                      v-model="openEndDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="intent.end_date"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          clearable
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="intent.end_date"
                        color="primary"
                        @input="openEndDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openEndTime"
                      v-model="openEndTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="intent.end_time"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      :disabled="intent.end_date == null"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="intent.end_time"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          :disabled="intent.end_date == null"
                          v-on="on"
                        />
                      </template>
                      <v-time-picker
                        v-if="openEndTime"
                        v-model="intent.end_time"
                        full-width
                        @click:minute="$refs.openEndTime.save(intent.end_time)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        intent.end_date = null
                        intent.end_time = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>

          <div class="form-control" :class="{ 'has-error': errors.has('startdate') }">
            <input
              v-model="startTimeFormat"
              v-validate="endTimeFormat ? '' : ''"
              type="hidden"
              :data-vv-as="$t('Start date')"
              name="startdate"
            />
            <input
              ref="beforeTarget"
              v-model="endTimeFormat"
              :data-vv-as="$t('End date')"
              name="enddate"
              type="hidden"
            />

            <span v-if="errors.has('startdate')" class="text-error">
              {{ errors.first('startdate') }}
            </span>
          </div>
        </div>
      </template>
      <div v-else>
        <template>
          <div class="form-control" style="display: flow-root">
            <span class="mt-2"> {{ $t('not_sending_message_to_the_same_person_within') }}</span>
            <input
              v-model="intent.not_reply_within_seconds"
              type="number"
              pattern="[0-9]*"
              placeholder="-"
              inputmode="numeric"
              class="form-control ml-2 mr-2"
              style="width: 90px"
            />
            <span> {{ $t('minute') }}</span>
          </div>
        </template>
        <template>
          <div class="form-control" style="display: flow-root">
            <span class="mt-2"> {{ $t('send_message_to_same_person') }}</span>
            <input
              v-model="intent.not_reply_within_times"
              type="number"
              pattern="[0-9]*"
              placeholder="-"
              inputmode="numeric"
              class="form-control ml-2 mr-2"
              style="width: 90px"
            /><span> {{ $t('time_day') }}</span>
          </div>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: {
    ToggleButton
  },
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      status: false,
      onlytime: false,
      startDate: null,
      startTime: null,
      openStartDate: false,
      openStartTime: false,
      endDate: null,
      endTime: null,
      openEndDate: false,
      openEndTime: false,
      intent: {}
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isBbq() {
      return this.$store.state.bbqPage.includes(this.selectedBot.pageid)
    },
    startTimeFormat: function () {
      let time = null
      const vm = this

      try {
        time = `${vm.intent.start_date} ${vm.formatTime(vm.intent.start_time)}:00`
      } catch (error) {
        console.error(error)
      }

      return time
    },
    endTimeFormat: function () {
      let time = null
      const vm = this

      if (vm.intent.end_date) {
        time = `${vm.intent.end_date}   ${vm.formatTime(vm.intent.end_time, {
          defaultHour: 23,
          defaultMinius: 59
        })}:00`
      }
      return time
    }
  },
  watch: {
    value: {
      handler() {
        this.intent = this.value
      },
      deep: true
    },
    intent: {
      handler() {
        this.handleUpdateIntent()
      },
      deep: true
    }
  },
  mounted() {
    this.intent = this.value
    if (this.intent.not_reply_within_times) {
      this.status = true
    }
  },
  methods: {
    handleUpdateIntent() {
      if (!this.status) {
        this.intent.not_reply_within_times = null
      }
      this.$emit('input', this.intent)
    },
    onChangeToggle() {
      this.status = !this.status
      if (!this.status) {
        this.intent.not_reply_within_times = null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentBeaconFrequency.vue